import React from 'react';
import { classIf, iconSportCssClass } from '../../../../data/utils';
import InEvidenzaCompetitionItem from './InEvidenzaCompetitionItem';

export default function InEvidenzaSportItem(props) {
    const startCollapsed = props.startCollapsed;

    const icoSport = iconSportCssClass(props.id, props.iconClass);
    return (
        <div className="regione-widget">
            <div className={"elemento-competizioni-widget pointer toggle-nascondi-live tog-menu" + classIf(startCollapsed, 'collapsed')} data-toggle="collapse" data-target={`#in-evidenza-menu-${props.id}`}>
                <div className="paese-widget-sx">
                    <div className="d-flex d-centro-v">
                        <div className={`icona-sport img-fluid margine-dx-mezzo ico-sport ${icoSport}`}></div>
                        {props.descrizione}
                    </div>
                </div>
                <span>{props.competitions.length}</span>
            </div>
            <div className={"competizione-sub collapse" + (startCollapsed ? '' : ' show')} id={`in-evidenza-menu-${props.id}`}>
                {props.competitions.map(c =>
                    <InEvidenzaCompetitionItem key={c.id} {...c} />
                )}
            </div>
        </div>
    );
}
